<main class="home-container">

  <!-- Legacy hero with illustration kept for reference
  <header class="home-hero">
    <div class="home-hero__content">
      <span class="home-hero__badge">TNC Engine</span>
      <h1 class="home-hero__title">{{ 'home.heroTitle' | translate }}</h1>
    </div>
    <div class="home-hero__graphic" aria-hidden="true">
      <img src="mano.png" alt="" class="home-hero__graphic-img">
    </div>
  </header>
  -->

  <!-- Hero + Video -->
  <header class="home-hero home-hero--split">
    <div class="home-hero__text">
      <div class="home-hero__logo">
        <img src="assets/images/logo-dark-blue.svg"
             [attr.alt]="('sidebar.logoAlt' | translate)"
             class="home-hero__logo-img">
      </div>
      <h1 class="home-hero__title home-hero__title--minimal"
          [innerHTML]="heroTitle">
      </h1>
    </div>
    <div class="home-hero__video">
      <video controls>
        <source src="https://js.tncid.app/tnc-engine/video/VIDEO%20TNC%20Engine%20(1).mp4" type="video/mp4">
      </video>
    </div>
  </header>

  <!-- Sezione novità -->
  <section class="news-section">
    <div class="news-section__header">
      <span class="news-section__accent"></span>
      <p class="news-section__subtitle">{{ 'home.newsSubtitle' | translate }}</p>
    </div>

    <!-- Grid delle card -->
    <div class="news-cards">

      <!-- Box 1: branded TNC → news-portfolio -->
      <a href="https://www.thenewco.tech/news-portfolio/" target="_blank" rel="noopener noreferrer" class="news-card news-card--branded">
        <div class="news-card__brand-bg" aria-hidden="true"></div>
        <img src="https://www.thenewco.tech/wp-content/uploads/2025/03/thenewco.svg" alt="" class="news-card__brand-img">
        <div class="news-card__body">
          <h3 class="news-card__title">{{ 'home.branded.title' | translate }}</h3>
          <p class="news-card__excerpt">{{ 'home.branded.excerpt' | translate }}</p>
          <span class="news-card__readmore">{{ 'home.branded.cta' | translate }} <span class="news-card__arrow">→</span></span>
        </div>
      </a>

      <!-- Box 2: articolo copy -->
      <a href="https://www.thenewco.tech/news/come-sfruttare-una-migliore-gestione-dei-dati-di-prima-parte-copy/" target="_blank" rel="noopener noreferrer" class="news-card">
        <div class="news-card__visual" style="background-image: url('https://www.thenewco.tech/wp-content/uploads/2025/11/Cover-Articolo-Piemme.png')"></div>
        <div class="news-card__body">
          <span class="news-card__date">26 Nov <span class="news-card__lang" *ngIf="isEnglish">(lang: IT)</span></span>
          <h3 class="news-card__title">{{ 'home.article1.title' | translate }}</h3>
          <p class="news-card__excerpt">{{ 'home.article1.excerpt' | translate }}</p>
          <span class="news-card__readmore">{{ 'home.readMore' | translate }} <span class="news-card__arrow">→</span></span>
        </div>
      </a>

      <!-- Box 3: articolo originale -->
      <a href="https://www.thenewco.tech/news/come-sfruttare-una-migliore-gestione-dei-dati-di-prima-parte/" target="_blank" rel="noopener noreferrer" class="news-card">
        <div class="news-card__visual" style="background-image: url('https://www.thenewco.tech/wp-content/uploads/2025/03/articolo1-1.jpg')"></div>
        <div class="news-card__body">
          <span class="news-card__date">19 Mar <span class="news-card__lang" *ngIf="isEnglish">(lang: IT)</span></span>
          <h3 class="news-card__title">{{ 'home.article2.title' | translate }}</h3>
          <p class="news-card__excerpt">{{ 'home.article2.excerpt' | translate }}</p>
          <span class="news-card__readmore">{{ 'home.readMore' | translate }} <span class="news-card__arrow">→</span></span>
        </div>
      </a>

    </div>
  </section>

</main>
